import { render, staticRenderFns } from "./organization-risk-target-definition.vue?vue&type=template&id=32d5cb6e&scoped=true&"
import script from "./organization-risk-target-definition.vue?vue&type=script&lang=js&"
export * from "./organization-risk-target-definition.vue?vue&type=script&lang=js&"
import style0 from "./organization-risk-target-definition.vue?vue&type=style&index=0&id=32d5cb6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d5cb6e",
  null
  
)

export default component.exports